import { ESTADOS_LLAMADAS_CHOICE, EstadosLlamadaEnumChoice, formatHour, gridSize, gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg6, parentescoMockupData, texto } from "@/shared";
import { Agendamiento, Contrato } from "@/shared/interfaces";
import { Grid, Icon, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import PersonIcon from '@mui/icons-material/Person';
import { CustomAutocomplete, CustomAutocompleteArrString, CustomTextArea, CustomTextField, CustomTextFieldNoForm, SingleButton, SingleIconButton, TabTexLabelCustomSpace, TabTextLabel } from "@/shared/components/ui";
import CustomCellphoneTextField from "@/shared/components/ui/CustomCellphoneTextField";
import { SaveFormDataAgendamiento } from "@/erp/operaciones/agendamiento/shared/interface/SaveFormDataAgendamiento.interface";
import ImagesWithZoom from "@/shared/components/ui/Images/ImagesWithZoom";
import ImageIcon from '@mui/icons-material/Image';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import { useMemo, useState } from "react";
import { useFetchUbicacionProductoSimple } from "@/shared/actions/erp";
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { SelectDateTimerSchedulingPyl } from "@/erp/operaciones/agendamiento/shared/components/calendario-preagendamiento-pyl/SelectDateTimerSchedulingPyl";
import { ServiceAndOthersPartPreagendamientoForm } from "@/erp/operaciones/preagendamiento/shared/components";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AgendamientoOrdenServicioUbicacionContrato from "./AgendamientoOrdenServicioUbicacionContrato";
import AgendamientoOrdenServicioVision360 from "./AgendamientoOrdenServicioVision360";
import useSelectDateTimerPreScheduling from "@/erp/sale/component/calendario-preagendamiento-venta/useSelectDateTimerPreScheduling.store";
import OtrosConceptosVisita from "../otros-conceptos/OtrosConceptosVisita";
import { usePreciosConceptosVisita } from "../otros-conceptos/usePreciosConceptosVisita";
import TipoInstalacionSelector from "../tipo-instalacion/TipoInstalacionSelector";
import { useTiposInstalacion } from "../tipo-instalacion/useTiposInstalacion";

export type AgendamientoSingleOrdenServicioVisitaProps = {
    form: UseFormReturn<SaveFormDataAgendamiento>;
    shrink?: boolean
    agendamiento: Agendamiento;
    isCorrectingData?: boolean;
    contrato: Contrato
}

export default function AgendamientoSingleOrdenServicioVisita({
    form,
    shrink,
    contrato,
    agendamiento,
    isCorrectingData

}: AgendamientoSingleOrdenServicioVisitaProps) {
    //form
    const { errors } = form?.formState;
    // Otros conceptos editable solo en En Espera / Agendado (estado_agendamiento
    // EN ESPERA / EN PAUSA / FINALIZADO=agendado); read-only en los demás tabs.
    const _estadoAg = (agendamiento?.estado_agendamiento || "").toUpperCase();
    const puedeEditarConceptos = ["EN ESPERA", "EN PAUSA", "FINALIZADO"].includes(_estadoAg);
    const { conceptos: catalogoConceptos, metodosPago } = usePreciosConceptosVisita();
    const { tipos: tiposInstalacion } = useTiposInstalacion();
    // Stock por producto en la ubicación de la flota (referencia): mismo control
    // que en activaciones, ya que aquí también hay flota asignada.
    const _ubicacionFlotaOp = (agendamiento?.flota_data as any)?.ubicacion;
    const { data: _invStockOp } = useFetchUbicacionProductoSimple({
        enabled: !!_ubicacionFlotaOp,
        params: {
            page: 1,
            page_size: 500,
            estado: true,
            filterByState: false,
            es_para_venta: true,
            ubicacion: _ubicacionFlotaOp,
        } as any,
    });
    const stockPorProductoOp = useMemo(() => {
        const m: Record<string, number> = {};
        const arr = (_invStockOp as any)?.data?.data || [];
        for (const up of arr) {
            const idp = up?.producto_data?.id_producto || up?.id;
            if (idp) m[idp] = Number(up?.cantidad ?? 0);
        }
        return m;
    }, [_invStockOp]);
    //state
    const [isVisibleCalendario, setIsVisibleCalendario] = useState(false)
    const [canViewDatosServicio, setCanViewDatosServicio] = useState(false)
    //flota
    const setSelectFloat = useSelectDateTimerPreScheduling(s=>s.setSelectFloat)
    const setPlanner = useSelectDateTimerPreScheduling(s=>s.setPlanner)
    //hanndlers
    const onEditHorario = async() => {
        if(isVisibleCalendario){
            form.reset({
                ...form.getValues(),
                flota:agendamiento?.flota || "",
                flotaRaw:agendamiento?.flota_data || {}
            });
            return
        }
        setSelectFloat(agendamiento?.flota || "");
        setPlanner(agendamiento?.flota || "")
    }
    //console.log('agendamiento nap',agendamiento)
    console.log('canViewDatosServicio', canViewDatosServicio)
    console.log('iscorrect',    isCorrectingData)
    return (
        <Grid item container spacing={3}>
            <Grid item {...gridSizeMdLg12} display={'inline-flex'} alignItems={'center'}>
                <Icon sx={{ marginRight: 1 }}>
                    <PersonIcon color="primary" />
                </Icon>
                <TabTextLabel text="Información Personal"
                    pt={0}
                    pl={0}
                    mt={0}
                    pb={0}
                />
            </Grid>
            {/*  /** informacion personal */}
            <>
                <CustomTextField
                    name="tipo_identificacion"
                    label="Tipo de Identificación"
                    control={form.control}
                    defaultValue={form.getValues().tipo_identificacion || ""}
                    error={!!errors.tipo_identificacion}
                    helperText={errors.tipo_identificacion?.message?.toString() ?? ""}
                    shrink={shrink}
                    size={gridSizeMdLg6}
                    disabled
                />
                <CustomTextField
                    name="identificacion"
                    label="No. Identificación"
                    control={form.control}
                    defaultValue={form.getValues().identificacion || ""}
                    error={errors.identificacion as any}
                    helperText={errors.identificacion?.message?.toString()}
                    shrink={shrink}
                    size={gridSizeMdLg6}
                    disabled
                />
                <CustomTextField
                    //endAdornmentInput={<TooltipIconEdit />}
                    name="persona_referencia_nombre"
                    label="Persona de referencia"
                    control={form.control}
                    defaultValue={form.getValues().persona_referencia_nombre || ""}
                    error={errors.persona_referencia_nombre}
                    helperText={errors.persona_referencia_nombre?.message?.toString()}
                    shrink={shrink}
                    disabled
                    //disabled={isCorrectingData}
                />
                <CustomAutocomplete
                    //endAdornmentInput={<TooltipIconEdit />}
                    size={gridSizeMdLg6}
                    label={texto.tipo_parentesco}
                    name="persona_referencia_parentesco"
                    options={parentescoMockupData || []}
                    valueKey={"nombre"}
                    defaultValue={form.getValues().persona_referencia_parentesco}
                    isLoadingData={false}
                    control={form.control}
                    error={errors.persona_referencia_parentesco}
                    helperText={errors.persona_referencia_parentesco?.message}
                    disabled
                
                />
                <CustomCellphoneTextField
                    //endAdornmentInput={<TooltipIconEdit />}
                    label="Celular Persona Referencia"
                    name="persona_referencia_celular"
                    control={form.control}
                    defaultValue={form.getValues().persona_referencia_celular}
                    error={errors.persona_referencia_celular}
                    helperText={errors.persona_referencia_celular?.message?.toString()}
                    shrink={shrink}
                    size={gridSizeMdLg6}
                    disabled
                    //disabled={isCorrectingData}
                    
                />
            </>
            {/* /** datos de venta  */}
            <Grid item {...gridSizeMdLg12} display={'inline-flex'} alignItems={'center'}>
                <Icon sx={{ marginRight: 1 }}>
                    <ImageIcon color="info" />
                </Icon>
                <TabTextLabel text="Fotos del cliente" pt={0} pl={0} mt={1} pb={0} />
            </Grid>
            {
                [
                    {
                        url: agendamiento?.preventa_data?.url_foto_identificacion_delantera,
                        alt: "Identificación Frontal"
                    },
                    {
                        url: agendamiento?.preventa_data?.url_foto_identificacion_posterior,
                        alt: "Identificación Posterior"
                    },
                    {
                        url: agendamiento?.preventa_data?.url_foto_aceptacion,
                        alt: "Foto Aceptación"
                    },
                    {
                        url: agendamiento?.preventa_data?.url_foto_cuenta_bancaria,
                        alt: "Cuenta Bancaria"
                    },
                    {
                        url: agendamiento?.preventa_data?.url_foto_ruc,
                        alt: "RUC"
                    },
                    {
                        url: agendamiento?.preventa_data?.url_foto_nombramiento,
                        alt: "Nombramiento"
                    },

                ].filter(e => e.url).map((elemento) => {
                    return <Grid item {...gridSizeMdLg4}>
                        <ImagesWithZoom
                            src={elemento.url!}
                            alt={elemento.alt}
                        />
                        <Typography variant="subtitle2">{elemento.alt}</Typography>
                    </Grid>
                })
            }
            {/* //estado llamada */}
            <Grid item {...gridSizeMdLg12} display={'inline-flex'} alignItems={'center'}>
                <Icon sx={{ marginRight: 1 }}>
                    <LocalPhoneIcon color="success" />
                </Icon>
                <TabTextLabel text={"Estado de la llamada"} pb={0} pl={0} mt={1} pt={0} />
            </Grid>
            <CustomCellphoneTextField
                //endAdornmentInput={<TooltipIconEdit />}
                name="celular"
                label="Celular Cliente"
                control={form.control}
                defaultValue={form.getValues().celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                shrink={shrink}
                size={gridSizeMdLg6}
                disabled
                //disabled={isCorrectingData}
            />
            <CustomCellphoneTextField
                //endAdornmentInput={<TooltipIconEdit />}
                name="celular_2"
                label="Celular 2 Cliente"
                control={form.control}
                defaultValue={form.getValues().celular_2 || ""}
                error={errors.celular_2}
                helperText={errors.celular_2?.message}
                shrink={shrink}
                size={gridSizeMdLg6}
                disabled
                //disabled={isCorrectingData}
            />
            {/* --------- estado llamada --------- */}
            <CustomAutocompleteArrString
                label="Estado de la llamada"
                name="estado_llamada"
                control={form.control}
                defaultValue={form.getValues().estado_llamada || ""}
                options={ESTADOS_LLAMADAS_CHOICE.filter(
                    (el) => el !== EstadosLlamadaEnumChoice.EN_ESPERA
                )}
                isLoadingData={false}
                error={errors.estado_llamada}
                helperText={errors.estado_llamada?.message}
                disableClearable
                disabled={isCorrectingData}
            />
            <CustomTextArea
                label="Observación Llamada"
                name="observacion_llamada"
                control={form.control}
                defaultValue={
                    form.getValues()?.observaciones?.observacion_llamada || ""
                }
                error={errors.observacion_llamada}
                helperText={errors.observacion_llamada?.message}
                required={false}
            />

            <Grid item {...gridSizeMdLg12} display={'inline-flex'} alignItems={'center'}>
                <Icon sx={{ marginRight: 1 }}>
                    <TravelExploreIcon color="primary" />
                </Icon>
                <TabTextLabel text="Ubicación"
                    pt={0}
                    pl={0}
                    mt={1}
                    pb={0}
                />
            </Grid>

            {/* aqui va la ubicacion */}
            <AgendamientoOrdenServicioUbicacionContrato
                form={form as any}
                contrato={contrato as any}
                errors={errors}
            />
            <Grid item xs={12} container justifyContent={"space-between"} alignItems={"center"}>
                <Grid item >
                    <Typography
                        variant="h6"
                        sx={{
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "start",
                            fontSize: ".9rem",
                            color: "#6c737fb0"
                        }}
                    >
                        ACTUALIZAR HORARIOS
                    </Typography>
                </Grid>
                <SingleIconButton
                    startIcon={<EventRepeatIcon />}
                    color={isVisibleCalendario ? "error" : "primary"}
                    label={isVisibleCalendario ? "Cancelar edición" : "Editar fecha"}
                    onClick={() => {
                        setIsVisibleCalendario(!isVisibleCalendario);
                        onEditHorario();
                    }}
                />
            </Grid>
            {!isVisibleCalendario && (
                <>
                    <CustomTextFieldNoForm
                        label="Fecha de visita"
                        //value={agendamiento?.fecha_instalacion || "N/A"}
                        value={agendamiento.fecha_visita || "N/A"}
                        size={gridSizeMdLg6}
                        disabled
                    />
                    <CustomTextFieldNoForm
                        label="Hora de visita"
                        value={
                            agendamiento?.hora_visita
                                ? formatHour(agendamiento?.hora_visita)
                                : "N/A"
                        }
                        size={gridSizeMdLg6}
                        disabled
                    />
                    <CustomTextFieldNoForm
                        label="Flota"
                        value={form.getValues().flotaRaw?.nombre ?? "N/A"}
                        size={gridSize}
                        disabled
                    />
                </>

            )}
            {
                isVisibleCalendario && (
                    <Grid item xs={12}>
                        <SelectDateTimerSchedulingPyl />
                    </Grid>
                )
            }
            {/* Tipo de instalación (árbol) */}
            <Grid item xs={12} sx={{ mt: 1 }}>
                <TipoInstalacionSelector
                    value={(form.watch("tipo_instalacion" as any) as any) || null}
                    onChange={(v) =>
                        form.setValue("tipo_instalacion" as any, v as any, { shouldDirty: true })
                    }
                    readOnly={!puedeEditarConceptos}
                    tipos={tiposInstalacion}
                />
            </Grid>

            {/* Otros conceptos (equipos + método de pago) */}
            <Grid item xs={12} sx={{ mt: 1 }}>
                <OtrosConceptosVisita
                    value={(form.watch("otros_conceptos" as any) as any) || []}
                    onChange={(v) =>
                        form.setValue("otros_conceptos" as any, v as any, { shouldDirty: true })
                    }
                    readOnly={!puedeEditarConceptos}
                    conceptos={catalogoConceptos}
                    metodosPago={metodosPago}
                    ubicacionFlota={_ubicacionFlotaOp}
                    stockPorProducto={stockPorProductoOp}
                />
            </Grid>

            {/*  // service */}
            { agendamiento?.nap && (
                <TabTexLabelCustomSpace
                    textContent="Datos de Servicio"
                    showCustomRightSpace={true}
                    customRightSpace={
                        <SingleButton
                            newCustomButton
                            startIcon={
                                canViewDatosServicio ? <ExpandLessIcon /> : <ExpandMoreIcon />
                            }
                            label={canViewDatosServicio ? "OCULTAR" : "VER MÁS"}
                            variant="text"
                            onClick={() => {
                                console.log('datos de servicio', canViewDatosServicio)
                                setCanViewDatosServicio((prev) => !prev);
                            }}
                        />
                    }
                />
            )}
            {canViewDatosServicio && (
                <ServiceAndOthersPartPreagendamientoForm
                    form={form as any}
                    preagendamiento={agendamiento as any}
                    isCorrectingData={isCorrectingData}
                    hidePromociones={true}
                    readOnlyNap={true}
                />
            )}

            {/* Visión 360 del cliente (FibraPoints, saldo/valores, pagos, tickets) */}
            <AgendamientoOrdenServicioVision360 contrato={contrato} />

        </Grid>
    )
}